/** Shown in the client note windows when saving fails without a server sentence (QA batch 14). */
export const NOTE_SAVE_FAILED = "The note couldn't be saved. Please try again.";
